import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { changeBackground } from '../utils/backgroundUtils';

export function useBackgroundManager() {
  const location = useLocation();

  useEffect(() => {
    const basePath = location.pathname.split('/')[1];
    const routePath = basePath ? `/${basePath}` : '/home';
    
    changeBackground(routePath);
  }, [location.pathname]);
}
